import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'react-bootstrap';
import fav from '../../images/blackHeartIcon.svg';
import notFav from '../../images/whiteHeartIcon.svg';
import shareIcon from '../../images/shareIcon.svg';
import { addFoodToFavorite, fetchFoodApiById, fetchDrinkApiById,
  removeFromFavorite } from '../../helpers';
import updateFavorites from '../../store/actions/favoriteRecipes.actions';
import './styles.css';

class DoneAndFavoriteCards extends Component {
  componentDidMount() {
    this.updateFavoriteRecipes();
  }

  updateFavoriteRecipes() {
    const { updateFavoriteList, updateFavoriteItems } = this.props;
    const favoriteRecipes = JSON.parse(localStorage.getItem('favoriteRecipes'));
    if (!favoriteRecipes) return;
    const list = favoriteRecipes.reduce((acc, curr) => {
      acc = {
        ...acc,
        [curr.id]: true,
      };
      return acc;
    }, {});
    updateFavoriteList(list);
    if (!updateFavoriteItems) return;
    updateFavoriteItems();
  }

  async favoriteThisItem(currentRecipe) {
    const removed = removeFromFavorite(currentRecipe.id);
    if (!removed) {
      const { type } = currentRecipe;
      const fetchFoodOrDrink = {
        comida: (id) => fetchFoodApiById(id),
        bebida: (id) => fetchDrinkApiById(id),
        comidas: (id) => fetchFoodApiById(id),
        bebidas: (id) => fetchDrinkApiById(id),
      };
      const foodOrDrink = await fetchFoodOrDrink[type](currentRecipe.id);
      addFoodToFavorite(foodOrDrink, currentRecipe.type);
    }
    this.updateFavoriteRecipes();
  }

  render() {
    const { recipes, filter, share, favoriteRecipe } = this.props;

    return (
      <div>
        <Container>
          <div className="recipes-grid-custom">
            {recipes && recipes.filter((element) => !filter
        || filter === 'all' || element.type === filter)
              .map((obj, index) => (
                <div key={ obj.id } className="recipe-card-custom">
                  <div className="recipe-card-image-wrapper">
                    <Link to={ `${obj.type}s/${obj.id}` }>
                      <img
                        data-testid={ `${index}-horizontal-image` }
                        alt={ `Foto de ${obj.name}` }
                        src={ `${obj.image}` }
                        className="linkImage"
                        loading="lazy"
                      />
                    </Link>
                    <div className="recipe-card-badge">
                      <span data-testid={ `${index}-horizontal-top-text` }>
                        {`${obj.alcoholicOrNot || ''} ${obj.area || ''} ${obj.category || ''}`.trim()}
                      </span>
                    </div>
                  </div>

                  <div className="recipe-card-content">
                    <div>
                      <Link className="recipe-link" to={ `${obj.type}s/${obj.id}` }>
                        <h3 data-testid={ `${index}-horizontal-name` } className="recipe-card-title">
                          {obj.name}
                        </h3>
                      </Link>
                      {obj.doneDate && (
                        <p data-testid={ `${index}-horizontal-done-date` } className="done-date-text">
                          {obj.doneDate}
                        </p>
                      )}

                      {obj.tags && obj.tags.length > 0 && (
                        <div className="tags mt-2">
                          {obj.tags.map((tag) => (
                            <span
                              className="filter-button orange tag-chip-custom"
                              key={ tag }
                              data-testid={ `${index}-${tag}-horizontal-tag` }
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3 pt-2 border-top">
                      <button
                        className="recipe-button"
                        type="button"
                        aria-label="Compartilhar receita"
                        onClick={ () => share(obj) }
                      >
                        <img
                          alt="Compartilhar"
                          data-testid={ `${index}-horizontal-share-btn` }
                          src={ shareIcon }
                        />
                      </button>
                      <button
                        className="recipe-button"
                        type="button"
                        aria-label="Favoritar ou desfavoritar receita"
                        onClick={ () => this.favoriteThisItem(obj) }
                      >
                        <img
                          src={ favoriteRecipe[Number(obj.id)] ? fav : notFav }
                          alt="Favoritar"
                          data-testid={ `${index}-horizontal-favorite-btn` }
                        />
                      </button>
                    </div>
                  </div>
                </div>))}
          </div>
        </Container>
      </div>
    );
  }
}

DoneAndFavoriteCards.propTypes = {
  recipes: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.string.isRequired,
  share: PropTypes.func.isRequired,
  updateFavoriteList: PropTypes.func.isRequired,
  favoriteRecipe: PropTypes.shape({}).isRequired,
  updateFavoriteItems: PropTypes.func,
};

DoneAndFavoriteCards.defaultProps = {
  updateFavoriteItems: null,
};

const mapStateToProps = (state) => ({
  favoriteRecipe: state.favoriteRecipes,
});

const mapDispatchToProps = (dispatch) => ({
  updateFavoriteList: (favorites) => dispatch(updateFavorites(favorites)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DoneAndFavoriteCards);
